import React from 'react'
import { cleanStyles } from 'helpers'

import Card from 'voting/components/Card/Card'
import Video from 'voting/components/Video/Video'
import CardHeading from 'voting/components/CardHeading/CardHeading'

import s from './Post.scss'


const Post = ({ className, post, children }) => {
  const {
    city, author, date, title, image, topDescription, description, bottomDescription, media,
  } = post

  return (
    <div className={s.card}>
      <CardHeading
        {...{ city, title, image }}
      />
      <div>
        <div className={s.bold} dangerouslySetInnerHTML={{ __html: cleanStyles(topDescription) }} />
        {
          Boolean(description) && (
            <div className={s.text} dangerouslySetInnerHTML={{ __html: cleanStyles(description) }} />
          )
        }
        {
          Boolean(media && media.length) && (
            <div className={s.media}>
              {
                media.map((url, index) => (
                  <div key={index} className={s.mediaItem}>
                    {
                      /youtu.be/.test(url) ? (
                        <Video
                          type="youtube"
                          url={url}
                        />
                      ) : (
                        <img className={s.image} src={url} />
                      )
                    }
                  </div>
                ))
              }
            </div>
          )
        }
        {
          Boolean(bottomDescription) && (
            <div className={s.text} dangerouslySetInnerHTML={{ __html: bottomDescription }} />
          )
        }
        <div className={s.buttons}>
          {children}
        </div>
      </div>
    </div>
  )
}


export default Post
